import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_FINANCEIRO = [
  {
    module: 'FIN_INST_FINANCEIRA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'cnpj'
      }
    ]
  },
  {
    module: 'FIN_FORMAS_PAGTO',
    colunas: [
      // {
      // active: true,
      // removable: true,
      //   field: 'codigo',
      // },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'forma_pagamento_sefaz.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'a_prazo'
      }
    ]
  },
  {
    module: 'FIN_COND_PAGTO',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'descricao',
        active: true,
        removable: false
      },
      {
        field: 'catalogo_usa',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'FIN_CENTRO_RESULTADO',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'centro_resultado.descricao'
      }
    ]
  },
  {
    module: 'FIN_NAT_FINANCEIRA',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'natureza_financeira.descricao'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'apropriacao'
      },
      {
        active: true,
        removable: true,
        field: 'periodicidade'
      },
      // {
      //   active: true,
      //   removable: true,
      //   field: 'conta_dre.descricao'
      // }
    ]
  },
  {
    module: 'FIN_CONTAS_RECEBER',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'created_at'
      },
      {
        active: true,
        removable: false,
        field: 'conta_receber.parceiro.nome_razao_social'
      },
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: true,
        field: 'conta_receber.origem'
      },
      {
        active: true,
        removable: true,
        field: 'vencimento'
      },
      {
        field: 'valor',
        active: true,
        removable: true
      },
      {
        active: true,
        removable: true,
        field: 'forma_pagto.nome'
      },
      {
        field: 'dias_atraso',
        active: true,
        removable: true
      },
      {
        field: 'valor_juros',
        active: true,
        removable: true
      },
      {
        field: 'desconto',
        active: true,
        removable: true
      },
      // {
      //   field: 'valor_renegociado',
      //   active: true,
      //   removable: true
      // },
      // {
      //   field: 'valor_multa',
      // active: true,
      // removable: true,
      // },
      // {
      //   field: 'valor_mora
      // 6mora',
      // active: true,
      // removable: true,
      // },
      {
        active: true,
        removable: true,
        field: 'pagamentos.data_hora'
      },
      {
        field: 'valor_total_pagtos',
        active: true,
        removable: true
      },
      {
        field: 'valor_total_ha_pagar',
        active: true,
        removable: true
      },
      {
        field: 'valor_total_ha_pagar_com_juros',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'FIN_CONTAS_PAGAR',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'created_at'
      },
      {
        active: true,
        removable: false,
        field: 'conta_pagar.fornecedor.parceiro.nome_razao_social'
      },
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: true,
        field: 'vencimento'
      },
      {
        field: 'valor',
        active: true,
        removable: true
      },
      {
        active: true,
        removable: true,
        field: 'forma_pagto.nome'
      },
      {
        field: 'dias_atraso',
        active: true,
        removable: true
      },
      {
        field: 'valor_juros',
        active: true,
        removable: true
      },
      {
        field: 'desconto',
        active: true,
        removable: true
      },
      // {
      //   field: 'valor_multa',
      // active: true,
      // removable: true,
      // },
      // {
      //   field: 'valor_mora',
      // active: true,
      // removable: true,
      // },
      {
        active: true,
        removable: true,
        field: 'pagamentos.data_hora'
      },
      {
        field: 'valor_total_pagtos',
        active: true,
        removable: true
      },
      {
        field: 'valor_total_ha_pagar',
        active: true,
        removable: true
      },
      {
        field: 'valor_total_ha_pagar_com_juros',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'FIN_PORTADOR',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'padrao'
      },
      {
        active: true,
        removable: true,
        field: 'saldo_inicial'
      },
      {
        active: true,
        removable: true,
        field: 'saldo'
      }
    ]
  },
  {
    module: 'FIN_MOV_FINANCEIRA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: true,
        field: 'portador.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'observacao'
      },
      {
        active: true,
        removable: false,
        field: 'nome_parceiro'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'data_movimento'
      },
      {
        active: true,
        removable: true,
        field: 'is_conciliado'
      },
      {
        active: true,
        removable: true,
        field: 'status'
      }
    ]
  },
  {
    module: 'FIN_CONTA_DRE',
    colunas: [
      { active: true, removable: true, field: 'descricao' },
      { active: true, removable: true, field: 'classificacao' },
      { active: true, removable: true, field: 'codigo_reduzido' }
    ]
  },
  {
    module: 'FIN_CORRECAO_CUSTO_PEDIDO',
    colunas: [
      { field: 'numero', active: true, removable: false },
      {
        field: 'pre_cadastro_nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'vendedor_apelido_nome_fantasia',
        active: true,
        removable: true
      },
      { field: 'modelo_descricao', active: true, removable: true },
      { field: 'linha_montagem_descricao', active: true, removable: true },
      { field: 'custo', active: true, removable: true },
      { field: 'valor_unitario', active: true, removable: true },
      { field: 'quantidade', active: true, removable: true },
      { field: 'data_hora', active: true, removable: true },
      { field: 'previsao_entrega', active: true, removable: true },
      { field: 'referencia', active: true, removable: true },
      { field: 'status', active: true, removable: true }
    ]
  },
  {
    module: 'FIN_ESTORNO',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: true,
        field: 'parc_nome_razao_social'
      },
      {
        active: true,
        removable: true,
        field: 'data_hora'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'port_nome'
      },
      {
        active: true,
        removable: true,
        field: 'cont_origem'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      },
      {
        active: true,
        removable: true,
        field: 'status'
      }
    ]
  }
] as IColunasSettingsUser[];
